import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-assist",
  "use": "icon-assist-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-assist\"><path fill=\"#ffffff\" d=\"M430 689h164v-40.834a16 16 0 0 1 10.298-14.95 189.633 189.633 0 0 0 3.863-1.515C703.88 592.731 774 498.971 774 389.5 774 245.078 656.922 128 512.5 128S251 245.078 251 389.5c0 109.285 68.974 202.912 164.356 242.001 1.212 0.497 2.66 1.067 4.348 1.71A16 16 0 0 1 430 648.161V689z m0 64v29a8 8 0 0 0 8 8h148a8 8 0 0 0 8-8v-29H430z m229 71c0 17.673-14.327 32-32 32H399c-17.673 0-32-14.327-32-32V680.75C260.274 627.329 187 516.97 187 389.5 187 209.731 332.731 64 512.5 64S838 209.731 838 389.5c0 127.073-72.817 237.139-179 290.747V824z m-239 72h185c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32H420c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/assist.svg
// module id = ftMt
// module chunks = 31